import { devicesAPI, deviceFingerprint, shopSession, staffToken } from "../services/api";
import { unsentSales } from "../pos/utils/storage";

/**
 * Moving this install to another of the user's shops.
 *
 * Each shop licenses its own devices, so the first time this phone opens a shop
 * it is activated there too — with the name it already has, no code to type — and
 * takes one of that shop's slots. Its token is kept, so switching back and forth
 * afterwards costs nothing. The till's shift (staff token) belongs to the shop it
 * was unlocked in, so it ends; and a page reload starts every screen on the new
 * shop rather than carrying the old one's data along.
 *
 * Refused while sales rung up offline here are still waiting to be sent: they
 * belong to this shop and are replayed by its till.
 */
export class SwitchBlocked extends Error {
  constructor(code, details) {
    super(code);
    this.code = code;
    this.details = details;
  }
}

const suggestedLabel = () => {
  const ua = navigator.userAgent;
  if (/iPad|Tablet/i.test(ua)) return "Tablet";
  if (/iPhone|Android|Mobile/i.test(ua)) return "Phone";
  return "Computer";
};

export const switchToShop = async (shop) => {
  if (unsentSales() > 0) throw new SwitchBlocked("UNSENT_SALES", { count: unsentSales() });

  let token = shopSession.tokenFor(shop.id);

  if (!token) {
    try {
      const { data } = await devicesAPI.activate(
        {
          label: shopSession.label() || suggestedLabel(),
          platform: navigator.userAgent,
          fingerprint: deviceFingerprint(),
        },
        shop.id,
      );
      token = data.device_token;
    } catch (error) {
      const details = error.response?.data?.details;
      // Every slot of that shop is taken: name the devices so one can be freed
      if (details?.devices) throw new SwitchBlocked("DEVICE_LIMIT", details);
      throw error;
    }
  }

  shopSession.use(shop.id, token);
  staffToken.clear();
  window.location.assign("/admin");
};

/** Frees a slot in another of the user's shops (they must own it), from the switcher. */
export const freeSlotIn = (shopId, deviceId) => devicesAPI.revoke(deviceId, shopId);
